export default function truncate(str, max) {
  return str.length < max
    ? str
    : `${str.substr(0, str.substr(0, max).lastIndexOf(' '))}...`;
}
